import JSBridge from '@ucarinc/ulib-jsbridge';
import Env from './env'
/**
 * jsbridge调用
 */
export const call = (
  serviceName,
  params = {}
) => new Promise((resolve, reject) => {
    JSBridge.jsCallNative({
    protocol: serviceName,
    parameters: params,
    callBack: data => {
        try {
        data = JSBridge.handleData(data);
        if (data.status.success) {
            resolve(data);
        } else {
            reject(data);
        }
        } catch (error) {
        // 处理错误
        console.log(error);
        reject(data);
        }
    },
    });
});


/**
 * 注册监听handler
 */
export const callbackHandler = (protocol, cb) => {
    JSBridge.registerHandler({
        protocol,
        callBack: parameters => {
            cb(parameters);
        },
    });
};

/**
 * receiveTransfer 接收 native
 * @param cb
 */
export const receiveTransferCallBack = (cb) => {
  callbackHandler('receiveTransfer', cb);
};

/**
 * http调用
 */
export const http = ({ path, params }) => {
  return call('http', params);
};

/**
 * 获取经纬度
 */
export const location = () => {
  return call('location');
};

/**
 * transfer 传输数据
 * @param url
 * @param isCurrent  //是否只是当webview刷新 默认false
 * @param parameters
 */
export const transfer = (
  url,
  needGoBack,
  isCurrent,
  hasInfoBar,
  parameters
) => {
  return call('transfer', {
    url,
    needGoBack,
    isCurrent,
    hasInfoBar,
    parameters,
  });
};

/**
 *  退出webview
 * true 退出成功
 * false 退出失败
 */
export const popView = () => {
  return new Promise((resolve, reject) => {
      JSBridge.jsCallNative({
        protocol: 'popView',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          let flag = data.status.success
          if (data.status.success) {
            resolve(flag);
          } else {
            reject(flag);
          }
        },
      });
  });
};

/**
 *  获得当前登录用户的uid ，获得不到返回空字符串
 */
export const getUid = () => {
  return new Promise((resolve, reject) => {
      JSBridge.jsCallNative({
        protocol: 'getUid',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.Uid);
          } else {
            reject('');
          }
        },
      });
  });
};

export const UploadFileType = {
  giveBack: 45, // 在线处理系统物品归还图片
  report: 46, // 在线处理系统订单报备图片
  feedback: 47, // 在线处理系统我的反馈图片
}
/**
 *  上传图片（单张）
 *  入参 图片大小限制
 *  返回上传图片的ftp url
 * 上传失败返回空字符串
 */
export const uploadPic = (
  maxSize = 1024 * 5,
  uploadFileType = UploadFileType,
  width,
  height
) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'uploadPic',
        parameters: {
          maxSize,
          uploadFileType,
          width,
          height,
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.url);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};
/**
 *  选择订单
 *  返回选择的订单id
 *  无内容回空字符串
 */
export const selectOrder = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'selectOrder',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * 获得司机id
 * 无内容回空字符串
 */
export const getDriverId = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'getDriverId',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.driverId);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};
/**
 * 获得司机服务城市id
 * 无内容回空字符串
 */
export const getCityId = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'getCityId',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * 获取加密字符串
 * 无内容回空字符串
 */
export const getKeys = (keys = []) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'getKeys',
        parameters: {
          keys,
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.key);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * 登录
 * 登录调用到 true
 * 调用失败 false
 */
export const login = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'login',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};

/**
 * 确实支付密码
 * 确实 true
 * 失败 false
 */
export const confirmPayPassword = (mobile = '') => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'confirmPayPassword',
        parameters: {
          mobile,
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};

/**
 * 选择时间
 * 返回时间字符串  2018-12-19 2018-12
 * 失败 返回空字符串
 */
export const selectDate = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'selectDate',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.date);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * 仅iOS 下刷新UI 解决iOS 不重新渲染问题
 */
export const updateUI = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar && Env.getOSInfo().isIOS) {
      JSBridge.jsCallNative({
        protocol: 'updateUI',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      resolve(true);
    }
  });
};

export const ShareTye = {
  none: 0, // 未知渠道
  ShareTimeline: 1, // 微信好友
  AppMessage: 2, // 微信朋友圈
  QQ: 3,
  qqZone: 4,
  weibo: 5,
  message: 6,
}


/**
 * 仅iOS 下刷新UI 解决iOS 不重新渲染问题
 */
export const newShare = (conf) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'newShare',
        parameters: conf,
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};

/**
 * 选择通讯录手机号
 */
export const showAddressBook = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'showAddressBook',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.phoneNumber);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * 图片展示
 */
export const gallery = (
  images = '',
  current = 0
) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'gallery',
        parameters: {
          images,
          current: `${current}`,
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(true);
    }
  });
};
/**
 * 刷新webview
 */
export const reload = () => {
  if (Env.getAppInfo().isUCar) {
    JSBridge.registerHandler({
      protocol: 'reload',
      callBack: parameters => {
        return JSBridge.succData(parameters);
      },
    });
  }
};

/**
 * @description 获取司机当前服务城市信息
 * @returns {Promise<IServiceCity>}
 */
export const getServiceCity = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'getCityId',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * @description 调用SNS分享
 * @param {IShareConfig} conf
 * @returns {Promise<boolean>}
 */
export const shareSNS = (conf) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'share',
        parameters: conf,
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};

/**
 * @description 通过URL地址生成对应的二维码图片
 * @param {string} url 网页地址
 * @returns {Promise<string>}
 */
export const createQrCode = (url = '') => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'createQrCode',
        parameters: {
          url,
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.base64Str);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * @description 唤起城市选择控件
 * @returns {(Promise<IServiceCity | null>)}
 */
export const selectCity = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'selectCity',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data);
          } else {
            reject(null);
          }
        },
      });
    } else {
      reject(null);
    }
  });
};
/**
 * @description 查看推荐历史页面
 * @returns {Promise<boolean>}
 */
export const goRecommandHistory = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'myRecommand',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};

/**
 * @description 打开相册
 * @param {number} maxSize 最大可选取照片数量
 * @param {object} [uploadParams={}] 上传图片额外参数对象
 * @param {boolean} [upload=false] 是否需要通过jsbridge上传图片
 * @returns {Promise<{url: string, base64Str: string}[]>} 图片对象数组
 */
export const openAlbum = (maxSize = 1, uploadParams = {}, upload = false) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'album',
        parameters: {
          maxSize,
          uploadParams,
          upload
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data.list);
          } else {
            reject([]);
          }
        },
      });
    } else {
      reject([]);
    }
  });
};

/**
 * @description 打开相机
 * @param {object} [uploadParams={}] 上传图片额外参数对象
 * @param {boolean} [upload=false] 是否需要通过jsbridge上传图片
 * @returns {Promise<{url: string, base64Str: string}>} 图片对象
 */
export const openCamera = (uploadParams = {}, upload = false) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'camera',
        parameters: {
          uploadParams,
          upload
        },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(data.data);
          } else {
            reject('');
          }
        },
      });
    } else {
      reject('');
    }
  });
};

/**
 * appTrack
 * @description 埋点上报
 * @param {string} eventCode
 * @param {object} remark
 * @returns {Promise<boolean>}
 */
export const appTrack = (
  eventCode,
  remark
) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'track',
        parameters: { event_code: eventCode, remark },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            resolve(false);
          }
        },
      });
    } else {
      resolve(false);
    }
  });
};

/**
 * openBrowser
 * @description 使用原生浏览器打开链接
 * @param {string} url
 * @returns {Promise<boolean>}
 */
export const openBrowser = (url = '') => {
  return new Promise(resolve => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'openBrowser',
        parameters: { url },
        callBack: data => {
          data = JSBridge.handleData(data);
          if (data.status.success) {
            resolve(true);
          } else {
            resolve(false);
          }
        },
      });
    } else {
      resolve(false);
    }
  });
};

// 积分商城-验证钱包密码
export const checkPayPwd = (operateType = 0, scb = () => {}) => {
  JSBridge.jsCallNative({
    protocol: 'newConfirmPayPassword',
    parameters: {
      operateType, // 当前操作类型:0 兑换，1 查看卡
    },
    callBack: data => {
      data = JSBridge.handleData(data);
      if (data.status.success) {
        scb(data.data.code);
      }
    }
  });
};

// 积分商城-复制
export const copyContent = (content = '', scb) => {
  JSBridge.jsCallNative({
    protocol: 'clipboard',
    parameters: {
      content, // 目前卡号券码、卡号密码 两个copy 功能
    },
    callBack: data => {
      data = JSBridge.handleData(data);
      if (data.status.success) {
        scb();
      }
    }
  });
};

/**
 * routeOrderWatch
 * @description 跳转APP听单监测页面
 * @param {*} sourceRepositoryId 源知识库ID
 * @returns {Promise<boolean>}
 */
export const routeOrderWatch = (sourceRepositoryId) => {
  return call('routeOrderWatch', {sourceRepositoryId});
};

/**
 * routeAppearanceUpload
 * @description 跳转APP仪容车貌上传页
 * @param {*} recordNum 接口获取的任务号
 * @returns {Promise<boolean>}
 */
export const routeAppearanceUpload = (recordNum) => {
  const obj = {
    p: 'appearance', // native页面对应枚举
    pa: {  // 接口返回参数
        recordNum
    }
  }
  return call('schemeSkip', {
    scheme: `ucardriver://host/?${JSON.stringify(obj)}`
  })
};

/**
 * @description 跳转司机端APP推荐购券、领券-我的推荐页面
 * @returns {Promise<boolean>}
 */
export const goCouponListRecommandHistory = () => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'couponList',
        parameters: {},
        callBack: data => {
          data = JSBridge.handleData(data);
          console.log('data???',data)
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};

/**
 * @description 司机招募<加入我们>跳转到代办事项
 * @param {*} type 立即加入类型 1 专车 2 舒享
 * @returns {Promise<boolean>}
 */
 export const routeToDoList = (identityFlag) => {
  return new Promise((resolve, reject) => {
    if (Env.getAppInfo().isUCar) {
      JSBridge.jsCallNative({
        protocol: 'navigator',
        parameters: { identityFlag, path: "/recruit/todo" },
        callBack: data => {
          data = JSBridge.handleData(data);
          console.log('data???',data)
          if (data.status.success) {
            resolve(true);
          } else {
            reject(false);
          }
        },
      });
    } else {
      reject(false);
    }
  });
};
